import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polygon,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Polygon,
          {
            points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "22", y2: "15.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "22 8.5 12 15.5 2 8.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "2 15.5 12 8.5 22 15.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "2", y2: "8.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Codepen";
const Codepen = memo(themed(Icon));
export {
  Codepen
};
//# sourceMappingURL=codepen.js.map
